import {priority} from '@priority-software/priority-proto-api/lib';
import {optionsValue} from '../../components/BooleanButtons/constants';
import texts from '../../texts';

type IField = priority.netitems.form.IField;

export const isStepFinished = questions => {
    if (questions.length > 0) {
        const mainQuestion = questions[0];

        return mainQuestion?.value !== 0;
    }
    return false;
};

export const isSubmittable = steps => {
    const ids = Object.keys(steps);
    return ids.some(id => steps[id]?.questions?.some(q => q.value === 1 || q.value === 2));
};

export function getFieldValue(field?: IField) {
    return field ? Object.values(field.Value)[0] : undefined;
}

export const isMainQuestion = (questions: Array<any>, ScrLine: number) => {
    return questions.find(item => item.ScrLine === ScrLine)?.isMain;
};

export const updateQuestionValue = (questions: Array<any>, ScrLine: number, value: number) => {
    const isMain = isMainQuestion(questions, ScrLine);
    const isNegativeAction = value !== optionsValue.accept;

    if (isMain && isNegativeAction) {
        // If the user answer with `no` value, or undo button selection, we should update sub-questions
        return questions.map((item, index) => ({
            ...item,
            value: value === optionsValue.decline && index === 0 ? value : optionsValue.skip
        }));
    }
    return questions.map(item => (item.ScrLine === ScrLine ? {...item, value} : item));
};

export const getFinalStepData = () => ({
    title: texts.final_step_title,
    subject: 'Done',
    isFinished: false,
    semiFilled: false,
    disabled: true,
    type: 'summary'
});
